import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { apiEndpoint } from 'configs'

const checkSellerInfo = createAsyncThunk(
  'cekSellerInfo/commodity',
  async ({ search, type, payment }, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }
      let url = `${apiEndpoint}/api/v1/bussines/transaction/checkuser?search=${search}&type=${type}`
      if (payment) {
        url += `&payment=${payment}`
      }

      const { data } = await axios.get(url, config)
      let finalData = {
        fullName: data.fullName,
        phoneNumber: data.phoneNumber,
        email: data.email,
        profileImg: data.profileImg,
        profileStatus: data.profileStatus ?? data.status,
        userId: data.userId,
        ...data,
      }

      return finalData
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const createOrder = createAsyncThunk(
  'sell/create/order/commodity',
  async (payload, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }
      let result = {
        ...payload,
        item: payload.item?.map((i) => ({
          orderItemId: i.orderItemId,
          SKU: i?.SKU || i?.sku || '',
          amount: i.amount,
          // imageUrl: i.imageUrl,
          // nameItem: i.nameItem,
          price: i.price,
          totalPrice: i.totalPrice,
          unit: i?.unit?.value ?? i?.unit ?? 'Kg',
          ...(i?.inventoryId && { inventoryId: i.inventoryId }),
        })),
      }

      const { data } = await axios.post(
        `${apiEndpoint}/api/v1/bussines/transaction/sell`,
        result,
        config,
      )

      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const uploadFile = createAsyncThunk(
  'sell/create/order/upload',
  async (payload, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${auth.token}`,
        },
      }

      const formData = new FormData()
      formData.append('file', payload)

      const { data } = await axios.post(
        `${apiEndpoint}/api/v1/upload`,
        formData,
        config,
      )

      const fileUrl =
        data?.url || data?.data?.url || (typeof data === 'string' ? data : null)
      if (!fileUrl) {
        return rejectWithValue(
          'Respon server upload tidak memiliki URL file yang valid',
        )
      }

      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const getComodities = createAsyncThunk(
  'sell/commodity/comodities',
  async (_, { rejectWithValue, getState, signal }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }

      // LOCAL STORAGE
      const storedFrequentItems =
        JSON.parse(localStorage.getItem('lastPickedCommoditiesSell')) || []

      // GET FREQUENT ITEMS FROM API
      let frequentItemsFromAPI = []
      try {
        const resFrequent = await axios.get(
          `${apiEndpoint}/api/v1/bussines/item-frequent?type=sell`,
          { ...config, signal },
        )

        frequentItemsFromAPI = resFrequent.data.map((e) => ({
          value: e.id,
          label: e.nameItem,
          id: e.id,
          img: e.linkFoto,
          sku: e.SKU,
          agencyModel: e.agencyModel,
        }))
      } catch {
        // Error fetching frequent items
      }

      // GET ALL ITEMS FROM API
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/items?origin=true&sortby=nameItem&sortdir=asc`,
        { ...config, signal },
      )

      let allItems = data.items
      if (data.totalItems > data.items.length) {
        const res = await axios.get(
          `${apiEndpoint}/api/v1/bussines/items?origin=true&sortby=nameItem&sortdir=asc&size=${data.totalItems}`,
          { ...config, signal },
        )
        allItems = res.data.items
      }

      // LOOKUP
      const allItemsMap = new Map()
      allItems.forEach((item) => {
        allItemsMap.set(item.id, {
          value: item.id,
          label: item.nameItem,
          id: item.id,
          img: item.linkFoto,
          sku: item.SKU,
          agencyModel: item.agencyModel,
        })
      })

      // UPDATE AND VALIDATE STORED FREQUENT ITEMS
      const updatedStoredItems = storedFrequentItems
        .map((storedItem) => {
          // CHECK IF ITEM STILL EXISTS IN MASTER ITEMS
          const validItem = allItemsMap.get(storedItem.id)
          if (!validItem) {
            return null
          }

          // UPDATE WITH LATEST DATA FROM MASTER ITEMS
          return {
            ...validItem,
          }
        })
        .filter((item) => item !== null)

      // MERGE WITH FREQUENT ITEM FROM API, AVOIDING DUPLICATES
      const mergedFrequentItems = [...updatedStoredItems]

      // ADD API FREQUENT ITEMS THAT ARE NOT ALREADY IN STORED ITEMS
      frequentItemsFromAPI.forEach((apiItem) => {
        const existsInStored = updatedStoredItems.some(
          (stored) => stored.id === apiItem.id,
        )
        if (!existsInStored) {
          mergedFrequentItems.push(apiItem)
        }
      })

      // LIMIT TO 5 ITEMS AND ENSURE UNIQUENESS
      const finalFrequentItems = mergedFrequentItems
        .filter(
          (item, index, self) =>
            index === self.findIndex((i) => i.id === item.id),
        )
        .slice(0, 5)

      // UPDATE LOCAL STORAGE WITH VALIDATED AND UPDATED FREQUENT ITEMS
      localStorage.setItem(
        'lastPickedCommoditiesSell',
        JSON.stringify(finalFrequentItems),
      )

      // PREPARE ALL OTHER ITEMS (EXCLUDING FREQUENT ITEMS)
      const allMappedItems = allItems
        .map((e) => ({
          value: e.id,
          label: e.nameItem,
          id: e.id,
          img: e.linkFoto,
          sku: e.SKU,
          agencyModel: e.agencyModel,
        }))
        .filter(
          (item) =>
            !finalFrequentItems.some((frequent) => frequent.id === item.id),
        )

      return [
        {
          label: 'TERAKHIR/SERING DIPILIH',
          options: finalFrequentItems,
        },
        {
          label: 'SEMUA BARANG',
          options: allMappedItems,
        },
      ]
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const getPackings = createAsyncThunk(
  'sell/commodity/packings',
  async (_, { rejectWithValue, getState, signal }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }

      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/inventorygroups/outer?isForTransaction=1`,
        { ...config, signal },
      )

      let allItems = data.items

      if (data.totalItems > data.items.length) {
        const res = await axios.get(
          `${apiEndpoint}/api/v1/bussines/inventorygroups/outer?isForTransaction=1&size=${data.totalItems}`,
          { ...config, signal },
        )
        allItems = res.data.items
      }

      const allMappedItems = allItems.map((e) => {
        const { label, ...rest } = e
        return {
          value: e.id,
          isPacking: true,
          nameItem: label,
          ...rest,
        }
      })

      return allMappedItems
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const getInventories = createAsyncThunk(
  'sell/commodity/inventories',
  async (_, { rejectWithValue, getState, signal }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/inventory?sortby=nameItem&sortdir=asc&groupId=null&isForTransaction=1`,
        { ...config, signal },
      )

      let allItems = data.items

      if (data.totalItems > data.items.length) {
        const res = await axios.get(
          `${apiEndpoint}/api/v1/bussines/inventory?sortby=nameItem&sortdir=asc&size=${data.totalItems}&groupId=null&isForTransaction=1`,
          { ...config, signal },
        )
        allItems = res.data.items
      }

      const allMappedItems = allItems.map((e) => ({
        value: e.id,
        warehouse: e?.warehouse?.name,
        nameItem: e?.item?.nameItem,
        amount: e?.amount,
        label2: e?.item?.nameItem,
        unit: e?.unit ?? e?.item?.unit,
        id: e.id,
        itemId: e?.item?.id,
        img: e?.item?.linkFoto,
        sku: e?.item?.SKU,
        ownerCode: e?.ownerCode,
        lotCode: e?.lots?.[0]?.data?.lotCode || e?.lotCode || null,
        projectId: e?.projectId ?? e?.project?.id ?? null,
        projectLabel:
          e?.projectLabel ??
          e?.project?.label ??
          e?.project?.title ??
          e?.project?.name ??
          null,
      }))

      return allMappedItems
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const getPackingDetails = createAsyncThunk(
  'sell/commodity/detailPackings',
  async ({ id }, { rejectWithValue, getState, signal }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }

      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/inventorygroups/${id}`,
        { ...config, signal },
      )
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const getInventorySelection = createAsyncThunk(
  'sell/commodity/inventorySelection',
  async ({ itemIds }, { rejectWithValue, getState, signal }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          itemIds,
        },
      }

      const { data } = await axios.get(
        `${apiEndpoint}/api/v1/bussines/inventory/selection`,
        { ...config, signal },
      )
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

const splitInventory = createAsyncThunk(
  'manage/split',
  async (payload, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const { data } = await axios.post(
        `${apiEndpoint}/api/v1/bussines/inventory/splittomany`,
        payload,
        config,
      )
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

// Export the functions
export {
  checkSellerInfo,
  createOrder,
  getComodities,
  getInventories,
  getInventorySelection,
  getPackingDetails,
  getPackings,
  splitInventory,
  uploadFile,
}
